import { Link } from 'react-router-dom';
import type { BoatPlace } from '../lib/boats';
import type { Member } from '../lib/members';

interface Props {
  places: BoatPlace[];
  members: (Member & { id: string })[];
}

function ownerLabel(
  place: BoatPlace,
  members: (Member & { id: string })[],
): string {
  if (!place.currentOwnerUid) return '(ingen ägare)';
  const m = members.find((x) => x.id === place.currentOwnerUid);
  return m ? `${m.firstName} ${m.lastName}` : '(okänd ägare)';
}

function statusLine(place: BoatPlace): { label: string; cls: string } {
  if (place.status === 'active') return { label: '✓ Aktiv', cls: 'text-green-700' };
  if (place.status === 'handed_over')
    return {
      label: `⚠ Överlämnad${place.statusNote ? ` — ${place.statusNote}` : ''}`,
      cls: 'text-amber-700',
    };
  return {
    label: `⚠ Avförd${place.statusNote ? ` ${place.statusNote.replace(/^Avförd\s*/i, '')}` : ''}`,
    cls: 'text-red-700',
  };
}

export default function AdminBoatPlaceList({ places, members }: Props) {
  const sorted = [...places].sort(
    (a, b) => Number(a.number) - Number(b.number),
  );
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold">Båtplatser ({places.length})</h1>
        <Link
          to="/admin/batplatser/ny"
          className="px-3 py-2 bg-navy text-white rounded text-sm"
        >
          + Ny plats
        </Link>
      </div>
      <ul className="space-y-2">
        {sorted.map((p) => {
          const status = statusLine(p);
          return (
            <li key={p.id}>
              <Link
                to={`/admin/batplatser/${p.id}`}
                className="block border rounded p-3 hover:bg-gray-50"
              >
                <div className="flex justify-between">
                  <span className="font-medium">Plats {p.number}</span>
                  <span>{ownerLabel(p, members)}</span>
                </div>
                <div className={`text-sm mt-1 ${status.cls}`}>
                  {status.label}
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
